import React from 'react';
import { Table } from '../../../components/Bootstrap';
import { Pagination, Chevron, Checkbox } from '../../../components';
import './ReportTable.scss';
import { IDAble, ReportTableRow } from './ReportTableRow';
import { ReportTopRow } from './ReportTopRow';

interface ReportTableProps<T extends IDAble> {
  page: number;
  maxPage: number;
  orderByHeaderIndex: number;
  orderByDirection: string;
  FooterComponent: any;
  rows: T[];
  checked: string[];
  loadingRowIndexes?: number[];
  loading: boolean;
  reportType: string;
  headers: string[];
  showDisbursementOption: boolean;
  onCheckAll();
  fetchCheckedReport();
  onChangeSection(type: string);
  columnValuesFromItem(item: T): string[];
  onPressCheckbox(item: T);
  fetchReport(ids: string[]);
  goToPrevPage();
  goToNextPage();
  onClickHeaderCell(index: number);
  classNameFromIndex?(index: number): string | undefined;
}

export class ReportTable<T extends IDAble> extends React.Component<ReportTableProps<T>> {
  constructor(props) {
    super(props);
    this.renderHeaderCell = this.renderHeaderCell.bind(this);
  }

  public renderHeaderCell(header, index) {
    const showChevron = this.props.orderByHeaderIndex === index;
    const chevronDirection = this.props.orderByDirection === 'desc' ? 'up' : 'down';
    const onClick = () => this.props.onClickHeaderCell(index);

    return (
      <th role='button' key={index} onClick={onClick}>
        {header}
        {showChevron && <Chevron direction={chevronDirection} width={10} className='ms-2' />}
      </th>
    );
  }

  public renderRows() {
    return this.props.rows.map((row, index) => (
      <ReportTableRow
        key={row.id}
        item={row}
        onPressCheckbox={this.props.onPressCheckbox}
        fetchReport={this.props.fetchReport}
        checked={this.props.checked.includes(row.id)}
        columnValuesFromItem={this.props.columnValuesFromItem}
        classNameFromIndex={this.props.classNameFromIndex}
        isLoading={this.props.loadingRowIndexes?.includes(index) ?? false}
      />
    ));
  }

  public renderContent() {
    if (this.props.loading || !this.props.rows) {
      return 'Loading...';
    }

    const allChecked = this.props.rows.length === this.props.checked.length;

    return (
      <div>
        <ReportTopRow
          onChangeSection={this.props.onChangeSection}
          fetchCheckedReport={this.props.fetchCheckedReport}
          reportType={this.props.reportType}
          showDisbursementOption={this.props.showDisbursementOption}
        />
        <div className='report-table-container'>
          <Table className='report-table'>
            <thead>
              <tr>
                <th className='report-table-checkbox-col'>
                  <Checkbox onClick={this.props.onCheckAll} isChecked={allChecked} />
                </th>
                {this.props.headers.map(this.renderHeaderCell)}
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>{this.renderRows()}</tbody>
          </Table>
        </div>
        <div className='d-flex justify-content-between report-table-footer'>
          <this.props.FooterComponent />
          <Pagination
            page={this.props.page}
            maxPage={this.props.maxPage}
            goToPrevPage={this.props.goToPrevPage}
            goToNextPage={this.props.goToNextPage}
          />
        </div>
      </div>
    );
  }

  render() {
    return <div className='report-card'>{this.renderContent()}</div>;
  }
}
